/*
 * Module for the Workflow Activity By Subject report criteria page
 */
rs.module("content/reports/criteria/workflowactivitybysubject",

    ["common/visibility"],

    function (visibility) {

        // Initialize the page
        function initialize(jsSelectors, subjectTypes) {

            var criteria = $.js(jsSelectors.criteria);

            var subjectTypeRadioContainer = criteria.js(jsSelectors.subjectTypeRadioContainer);
            var participantContainer = criteria.js(jsSelectors.participantContainer);

            // Register click event for subject type radio buttons 
            subjectTypeRadioContainer.find("input").on("click", () => updateSubjectTypeDisplay());

            // Handle dynamic display of subject type fields
            function updateSubjectTypeDisplay() {

                var selectedSubjectType = subjectTypeRadioContainer.find("input:checked").val();

                visibility.setVisible(participantContainer, selectedSubjectType == subjectTypes.participant);
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);